import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import ContextFactory from './contexts/contextFactory'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <ContextFactory />
  </React.StrictMode>
)
